export function accordion() {
    const $body = $('body');
    const accordion = $(".accordion:not(.opened)");
    const accordionItem = accordion.find(".accordion-item");
    const accordionItemTitle = accordionItem.find(".title");
    const isIE = !!document.documentMode;
    const isEdge = !isIE && !!window.StyleMedia;

    accordionItemTitle.on("click", function () {
        let $this = $(this);
        let parent = $this.closest('.accordion-item');
        if (!$this.hasClass('active')) {
            let graph = parent.find('.graph')[0];

            $this.addClass('active');
            parent.addClass('active');
            parent.find('.hidden-info').slideDown();

            if (window.innerWidth >= 1200) {
                if (!(isIE || isEdge)) {
                    let src = graph.getAttribute('data-json');
                    if (src) {
                        $(parent).find('img').hide();
                    }
                    if (!parent.find('svg').length) {
                        window.lottiejs.loadAnimation({
                            container: graph,
                            path: src,
                            renderer: "svg"
                        });
                    }
                }
            }
        } else {
            $this.removeClass('active');
            parent.removeClass('active');
            parent.find('.hidden-info').slideUp();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js